import { Box, Chip, Stack, Typography } from '@mui/material';

interface PageHeaderProps {
  /** Short label above the title (e.g. section family). */
  eyebrow?: string;
  title: string;
  description?: string;
  rightSlot?: React.ReactNode;
}

export function PageHeader({ eyebrow, title, description, rightSlot }: PageHeaderProps) {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      alignItems={{ xs: 'flex-start', sm: 'flex-end' }}
      justifyContent="space-between"
    >
      <Box sx={{ minWidth: 0 }}>
        {eyebrow ? (
          <Chip
            label={eyebrow}
            size="small"
            sx={{
              height: 24,
              mb: 1,
              fontWeight: 700,
              fontSize: 11,
              letterSpacing: 1.2,
              bgcolor: 'rgba(91, 156, 248, 0.12)',
              color: 'primary.light',
              border: '1px solid rgba(91, 156, 248, 0.28)',
            }}
          />
        ) : null}
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 800,
            letterSpacing: -0.03,
            color: 'text.primary',
          }}
        >
          {title}
        </Typography>
        {description ? (
          <Typography variant="body1" sx={{ opacity: 0.72, mt: 1, maxWidth: 720, lineHeight: 1.6 }}>
            {description}
          </Typography>
        ) : null}
      </Box>
      {rightSlot ? <Box sx={{ alignSelf: { xs: 'stretch', sm: 'auto' }, flexShrink: 0 }}>{rightSlot}</Box> : null}
    </Stack>
  );
}
